import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { hasAnyPermission, hasPermission, isRestrictedVendor } from '../utils/permissions';
import styles from './Sidebar.module.css';

const sidebarItems = [
  { to: '/vendors', label: 'Vendors', resource: 'vendors' },
  { to: '/facilities', label: 'Facilities', resource: 'facilities' },
  { to: '/equipment', label: 'Equipments', resource: 'equipment' },
  { to: '/requests', label: 'Requests', resource: 'requests', hideForVendor: true },
  { to: '/received-studies', label: 'Received Studies', resource: 'requests', hideForVendor: true },
  { to: '/equipment-usage', label: 'Equipment Usage', anyPermissions: [{ resource: 'requests' }, { resource: 'equipment' }] },
  {
    to: '/reports',
    label: 'Reports',
    anyPermissions: [
      { resource: 'requests' },
      { resource: 'equipment' },
      { resource: 'facilities' },
      { resource: 'vendors' },
    ],
  },
  {
    to: '/settings',
    label: 'Settings',
    anyPermissions: [
      { resource: 'procedures' },
      { resource: 'equipment_mapping' },
      { resource: 'revenue_distribution' },
      { resource: 'users' },
      { resource: 'permissions' },
    ],
  },
];

const Sidebar = () => {
  const { user } = useAuth();
  const visibleItems = sidebarItems.filter((item) => (
    !(item.hideForVendor && isRestrictedVendor(user))
    && (
      item.anyPermissions
        ? hasAnyPermission(user, item.anyPermissions)
        : hasPermission(user, item.resource)
    )
  ));

  return (
    <aside className={styles.sidebar}>
      <nav className={styles.nav} aria-label="Primary navigation">
        {visibleItems.map((item) => (
          <NavLink
            key={`${item.to}-${item.label}`}
            to={item.to}
            className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ''}`}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
